var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure connector")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_setup.providers, function (p) {
          return _c("div", { staticClass: "col col-4" }, [
            _c(
              "div",
              {
                staticClass: "card text-dark bg-light mb-3",
                class: { "border-primary": _setup.providerType == p.Type },
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    _setup.providerType = p.Type
                  },
                },
              },
              [
                p.LogoUrl
                  ? _c("img", {
                      staticClass: "card-img-top m-1",
                      staticStyle: { "max-height": "100px" },
                      attrs: { src: p.LogoUrl },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(p.Name)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v(_vm._s(p.Description)),
                  ]),
                ]),
              ]
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _setup.provider
        ? _c("iframe", {
            ref: "connectorProviderElement",
            staticStyle: { border: "none", width: "100%", height: "600px" },
            attrs: {
              name: "connectorProviderElement",
              src: _setup.configPageUrl,
            },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }